// extracted by mini-css-extract-plugin
export var container = "_fu-0";
export var icon = "_fu-1";
export var text = "_fu-2";